import React from 'react'
import logo from '../assets/img/hph-logo.png'

export default function Header() {
  return (
   <>

  <header className="hdr-transparent hdr-position-absolute">
    <div className="layer-stretch hdr-center pt-4 pb-4">
      <div className="row align-items-center">
        <div className="col-lg-4 d-none d-sm-none d-md-none d-lg-block d-xl-block">
          <div className="hdr-center-account text-left p-0">
            <a href="/login" className="font-14 mr-4">
              <i className="fas fa-sign-in-alt d-inline-block align-middle" />
              <span className="d-inline-block align-middle">Login</span>
            </a>
            <a href="index021c.html?route=register" className="font-14">
              <i className="fas fa-user-plus d-inline-block align-middle" />
              <span className="d-inline-block align-middle">Register</span>
            </a>
          </div>
        </div>
        <div className="col-md-6 col-lg-4">
          <div className="hdr-center-logo">
            <a href="/" className="d-inline-block">
              <img
                src={logo}
                alt="Klinikal Hospital"
              />
            </a>
          </div>
        </div>
        <div className="col-md-6 col-lg-4 d-none d-sm-none d-md-block d-lg-block d-xl-block text-right">
          <ul className="social-list social-list-white">
            <li>
              <a
                href="https://www.facebook.com/"
                className="fab fa-facebook rounded"
                target="_blank"
              />
            </li>
            <li>
              <a
                href="https://www.twitter.com/"
                className="fab fa-twitter rounded"
                target="_blank"
              />
            </li>
            <li>
              <a
                href="https://www.google.com/"
                className="fab fa-google rounded"
                target="_blank"
              />
            </li>
            <li>
              <a
                href="https://www.instagram.com/"
                className="fab fa-instagram rounded"
                target="_blank"
              />
            </li>
            <li>
              <a
                href="https://www.youtube.com/"
                className="fab fa-youtube rounded"
                target="_blank"
              />
            </li>
            <li>
              <a
                href="https://www.linkedin.com/"
                className="fab fa-linkedin rounded"
                target="_blank"
              />
            </li>
            <li>
              <a
                href="https://www.flickr.com/"
                className="fab fa-flickr rounded"
                target="_blank"
              />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div className="hdr-transparent-menu hdr-dark-background fixed-on-scroll-colored-background">
      <div className="hdr layer-stretch">
        <div className="row align-items-center">
          {/* Start Menu Section */}
          <ul className="col menu text-left">
            <li>
              <a href="/">
                Home</a>
            </li>
            {/* <li>
              <a href="index1b06.html?route=about">About Us </a>
            </li>
            <li>
              <a href="#">
                Services
                <i className="fa fa-chevron-down" />{" "}
              </a>
              <ul className="menu-dropdown">
                {" "}
                <li>
                  <a href="#">Service Style 1 </a>
                  <ul className="menu-dropdown menu-dropdown-left">
                    {" "}
                    <li>
                      <a href="index3531.html?route=services&theme=services-1">
                        Services Style 1{" "}
                      </a>
                    </li>{" "}
                    <li>
                      <a href="indexd66b.html?route=services&theme=services-4">
                        Services Style 1 with Right Sidebar{" "}
                      </a>
                    </li>{" "}
                    <li>
                      <a href="index64bf.html?route=services&theme=services-6">
                        Services Style 1 with left Sidebar{" "}
                      </a>
                    </li>
                  </ul>
                </li>{" "}
                <li>
                  <a href="#">Services Style 2 </a>
                  <ul className="menu-dropdown menu-dropdown-left">
                    {" "}
                    <li>
                      <a href="index2148.html?route=services&theme=services-2">
                        Services Style 2{" "}
                      </a>
                    </li>{" "}
                    <li>
                      <a href="indexa20a.html?route=services&theme=services-5">
                        Services Style 2 with Right Sidebar{" "}
                      </a>
                    </li>{" "}
                    <li>
                      <a href="indexc080.html?route=services&theme=services-7">
                        Services Style 2 with left Sidebar{" "}
                      </a>
                    </li>
                  </ul>
                </li>{" "}
                <li>
                  <a href="index7d2e.html?route=services&theme=services-3">
                    Services Style 3{" "}
                  </a>
                </li>
              </ul>
            </li>
            <li>
              <a href="#">
                Doctors
                <i className="fa fa-chevron-down" />{" "}
              </a>
              <ul className="menu-dropdown">
                {" "}
                <li>
                  <a href="#">Doctors Style 1 </a>
                  <ul className="menu-dropdown menu-dropdown-left">
                    {" "}
                    <li>
                      <a href="indexa2ff.html?route=doctors&theme=doctors-1">
                        Doctors Style 1{" "}
                      </a>
                    </li>{" "}
                    <li>
                      <a href="indexc2ac.html?route=doctors&theme=doctors-4">
                        Doctors Style 1 with Right Sidebar{" "}
                      </a>
                    </li>{" "}
                    <li>
                      <a href="index3afe.html?route=doctors&theme=doctors-7">
                        Doctors Style 1 with Left Sidebar{" "}
                      </a>
                    </li>
                  </ul>
                </li>{" "}
                <li>
                  <a href="#">Doctors Style 2 </a>
                  <ul className="menu-dropdown menu-dropdown-left">
                    {" "}
                    <li>
                      <a href="indexb232.html?route=doctors&theme=doctors-2">
                        Doctors Style 2{" "}
                      </a>
                    </li>{" "}
                    <li>
                      <a href="indexd9ef.html?route=doctors&theme=doctors-5">
                        Doctors Style 2 with Right Sidebar{" "}
                      </a>
                    </li>{" "}
                    <li>
                      <a href="indexc649.html?route=doctors&theme=doctors-8">
                        Doctors Style 2 with Left Sidebar{" "}
                      </a>
                    </li>
                  </ul>
                </li>{" "}
                <li>
                  <a href="#">Doctors Style 3 </a>
                  <ul className="menu-dropdown menu-dropdown-left">
                    {" "}
                    <li>
                      <a href="index1db8.html?route=doctors&theme=doctors-3">
                        Doctors Style 3{" "}
                      </a>
                    </li>{" "}
                    <li>
                      <a href="indexb367.html?route=doctors&theme=doctors-6">
                        Doctors Style 3 with Right Sidebar{" "}
                      </a>
                    </li>{" "}
                    <li>
                      <a href="indexcf50.html?route=doctors&theme=doctors-9">
                        Doctors Style 3 with Left Sidebar{" "}
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </li> */}
            <li>
              <a href="#">Contact Us </a>
            </li>
            <li>
              <a href="#">Gallery </a>
            </li>
          
            {/* <li>
              <a href="admin/index.html">Admin Panel </a>
            </li> */}
            <li>
              <a>
                My Account <i className="fa fa-chevron-down" />
              </a>
              <ul className="menu-dropdown">
                <li>
                  <a href="/login">Login</a>
                </li>
                <li>
                  <a href="#">Register</a>
                </li>
                <li>
                  <a href="#">Forgot Password</a>
                </li>
              </ul>
            </li>
            <li className="mobile-menu-close">
              <i className="fa fa-times" />
            </li>
          </ul>
          {/* End Menu Section */}
          <div id="menu-bar" className="col-2 col-md-auto">
            <a>
              <i className="fas fa-bars text-white" />
            </a>
          </div>
          <div className="col col-md-auto d-block d-sm-block d-md-block d-lg-block d-xl-block">
            <a
              href="/appointment"
              className="btn btn-primary btn-pill pt-2 pb-2"
            >
              <i className="far fa-calendar-plus mr-2" /> Make An Appointment
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
  {/* End Header Section */}


   </>
  )
}

